import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeficiencyTicketWatchersLogicService } from './logic/deficiency-ticket-watchers/deficiency-ticket-watchers-logic.service';
import { DeficiencyTicketWatchersService } from './logic/deficiency-ticket-watchers.service';
import { DeficiencyTicketWatchersDaoService } from './dao/deficiency-ticket-watchers-dao.service';
import { DeficiencyTicketWatchersDbDaoService } from './dao/deficiency-ticket-watchers-dao/deficiency-ticket-watchers-db-dao.service';
import { DeficiencyTicketWatchersDbTableDefinition } from './dao/deficiency-ticket-watchers-dao/deficiency-ticket-watchers-db-table-definition';
import { LocalDeficiencyTicketWatchersDbTableDefinition } from './dao/deficiency-ticket-watchers-dao/local-deficiency-ticket-watchers-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: DeficiencyTicketWatchersService, useClass: DeficiencyTicketWatchersLogicService },
    { provide: DeficiencyTicketWatchersDaoService, useClass: DeficiencyTicketWatchersDbDaoService },
    { provide: DeficiencyTicketWatchersDbTableDefinition },
    { provide: LocalDeficiencyTicketWatchersDbTableDefinition },
  ]
})
export class DeficiencyTicketWatchersModule {}
